import { cardStyles } from "../../../../core/Card.styles.js";
import { Section } from "../../../../patterns/Section.js";
import type { PageLayoutProps } from "../../../contract.js";
import type { BattleCreateContent } from "../../battlesContent.js";

/**
 * Building a battle, showroom layout: the boxes panel on the left, the settings and the entry in
 * one panel on the right. The design has no phone frame for it: on a phone
 * the panels stack, boxes first, and the entry closes the page.
 */
export function BattleCreateShowroomLayout({ sections }: PageLayoutProps<BattleCreateContent>) {
  return (
    <Section className="flex flex-col gap-6 pt-6 pb-20 md:gap-8 md:pt-10">
      {sections.heading}
      {sections.notice}
      <div className="grid grid-cols-1 items-start gap-6 lg:grid-cols-[minmax(0,1fr)_minmax(0,26rem)]">
        {sections.picks}
        {/* Hidden until a section in it renders (the boxes still loading leave both out). */}
        <div
          className={cardStyles({
            radius: "3xl",
            className:
              "hidden min-w-0 flex-col gap-8 p-5 has-[[data-template-section]>*]:flex md:p-7",
          })}
        >
          {sections.settings}
          {sections.entry}
        </div>
      </div>
    </Section>
  );
}
